<y42-orchestration-run-details
  *ngIf="data.runId; else NotFound"
  [runId]="data.runId"
  (redirectToAsset)="onRedirectToAsset($event)"
></y42-orchestration-run-details>

<ng-template #NotFound>
  <div class="w-full h-full">
    <p>No Run ID provided.</p>
  </div>
</ng-template>
